import { render, staticRenderFns } from "./PromoteView.vue?vue&type=template&id=6aa4c02f&scoped=true&"
import script from "./PromoteView.vue?vue&type=script&lang=ts&"
export * from "./PromoteView.vue?vue&type=script&lang=ts&"
import style0 from "./PromoteView.vue?vue&type=style&index=0&id=6aa4c02f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4c02f",
  null
  
)

export default component.exports